import { Component } from '@angular/core';
import { Location } from '@angular/common'

@Component({
  selector: 'envelope-shipping-documents',
  templateUrl: './envelope-shipping-documents.component.html'
})
export class EnvelopeShippingDocumentsComponent {  
  
  constructor(private location: Location) {}

  closeShipping() {   
    this.location.back();
  }
}